// extracted by mini-css-extract-plugin
export default {"popOverContainer":"AddNote_popOverContainer__Uc8Y3","flexContainer":"AddNote_flexContainer__okwQa","textarea":"AddNote_textarea__NagFw","addNoteTitle":"AddNote_addNoteTitle__4jPWl"};